import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import HeaderLogoPanel from './HeaderLogoPanel';
import HeaderMiddlePanel from './HeaderMiddlePanel';
import HeaderRightPanel from './HeaderRightPanel';
import { useIsMobile } from '../hooks/useIsMobile';

const Header: React.FC = () => {
  const { theme } = useTheme();
  const isMobile = useIsMobile();

  // Only one of the two arrangements is mounted. Previously both were rendered and one was
  // hidden with CSS, so HeaderLogoPanel and HeaderRightPanel each ran twice.
  return (
    <header className={`sticky top-0 z-[9999] flex flex-col md:flex-row h-auto md:h-12 shrink-0 border-b shadow-sm transition-colors duration-200 theme-bg-secondary bg-white border-0 border-b-1 ${theme === 'light' ? 'border-gray-200' : 'border-gray-700'}`}>
      {isMobile ? (
        /* Mobile Header - Two rows */
        <div className="w-full">
          {/* First Row - Logo spanning full width */}
          <div className="flex justify-center items-center py-3 px-4 w-full">
            <HeaderLogoPanel />
          </div>
          {/* Second Row - Profile Icons and Action Buttons */}
          <div className="flex justify-center items-center py-2 px-4">
            <HeaderRightPanel />
          </div>
        </div>
      ) : (
        /* Desktop Header - Original layout */
        <div className="flex w-full">
          {/* Header Logo Panel - Same width as Left Panel */}
          <HeaderLogoPanel />
          {/* Header Middle Panel - Flexible width */}
          <HeaderMiddlePanel />
          {/* Header Right Panel - Same width as Right Panel */}
          <HeaderRightPanel />
        </div>
      )}
    </header>
  );
};

export default Header; 
